/* VELVET GLOW – "Neu"-Badge in die Inhalt-Zeile (.velvet-content-block, z.B. neben "25 ml").
   Wird nur auf der Produktseite über price.liquid geladen. Externe Datei => kein Text im
   <script>-Tag => es kann nie ein "(" auf Karten o.ä. durchsickern. */
(function () {
  if (window.__vgNeuBadgeInit) return;
  window.__vgNeuBadgeInit = true;

  function label() {
    var l = (document.documentElement.getAttribute('lang') || 'de').toLowerCase().slice(0, 2);
    if (l === 'en') return 'New';
    if (l === 'fr') return 'Nouveau';
    if (l === 'it') return 'Nuovo';
    return 'Neu';
  }

  function insert() {
    var target = document.querySelector('.velvet-content-block');
    if (!target || target.querySelector('.vg-neu-badge')) return;
    var span = document.createElement('span');
    span.className = 'badge price__badge-sold-out vg-neu-badge';
    span.textContent = label();
    span.style.cssText = 'display:inline-flex;margin-inline-start:0.6rem;vertical-align:middle;';
    target.appendChild(span);
  }

  if (document.readyState !== 'loading') { insert(); }
  else { document.addEventListener('DOMContentLoaded', insert); }
})();
